<template>
    <ul class="inputs-ul" v-loading="loading">
        <li>
            <loginTextInput v-model="obj.login" disabled/>
        </li>

        <li>
            <div class="inline-box">
                <div class="inline-text-input">
                    <loginTextInput
                        v-model="obj.name"
                        :placeholder="i18n.tkey('lang_name')"
                        :disabled="eshopopeeTag"
                    />
                </div>

                <div class="inline-select">
                    <memmaleSelect
                        :disabled="eshopopeeTag"
                        v-model="obj.memmale"
                    />
                </div>
            </div>
        </li>

        <li>
            <div class="inline-box">
                <div class="inline-select">
                    <areaNumberSelect v-model="obj.mpfaccount" />
                </div>

                <div class="inline-text-input">
                    <loginTextInput
                        v-model="obj.telephone"
                        :disabled="eshopopeeTag"
                    />
                </div>
            </div>
        </li>

        <li>
            <div class="inline-box">
                <div class="inline-select">
                    <areaNumberSelect v-model="obj.mpfratio" />
                </div>

                <div class="inline-text-input">
                    <loginTextInput
                        v-model="obj.mobilephone"
                        :disabled="eshopopeeTag"
                    />

                </div>
            </div>
        </li>

        <li style="padding-top: 5px">
            <span tkey="部門">{{i18n.tkey("lang_department")}}</span> <departmentSelect v-model="obj.department" :disabled="true" />
        </li>

        <li style="padding-bottom: 10px">
            <span tkey="職位">{{i18n.tkey("lang_position")}}</span> <positionSelect v-model="obj.memposition" :disabled="true" />
        </li>

        <li>
            <div v-show="!showPasswordInput">
                <a
                    class="a-text"
                    :href="eshopopeeUrl"
                    target="eshopopee"
                    v-show="eshopopeeTag"
                >
                    <el-button type="primary" tkey="修改密碼">{{i18n.tkey("lang_modification_password")}}</el-button>
                </a>


                <el-button
                    type="primary"
                    @click="showPasswordInput = true"
                    v-show="!eshopopeeTag"
                    tkey="修改密碼"
                >
                    {{i18n.tkey("lang_modification_password")}}
                </el-button>
            </div>

            <div v-show="showPasswordInput">
                <loginPasswordInput v-model="obj.password" :placeholder="i18n.tkey('lang_password')" />
                <loginPasswordInput v-model="obj.repassword" :placeholder="i18n.tkey('lang_confirm_password')" />
            </div>

        </li>

        <li v-if="null != userCard" style="margin-top: 20px;margin-bottom: 20px;">
            <el-row v-show="null == cropperImgData">
                <el-col :span="cols">
                    <span tkey="用戶頭像">{{i18n.tkey("lang_head_portrait")}}</span>
                    <br>
                    <span class="upload-img-label">({{i18n.tkey("lang_Aspect_ratio")}} 1:1 {{i18n.tkey("lang_Suggested_Resolution")}} 100*100)</span>
                    <UploadImg
                        v-model="userCard.addinfo8"
                        :size-limit="512"
                        :width="100"
                        :height="100"
                        :useBtn="false"
                        :autoUpdate="false"
                        @selectComplete="uploadHeadImgCallback"
                        @deleteImg="deleteCardAddinfo8"
                    />
                </el-col>

                <el-col :span="cols">
                    <span tkey="半身像">{{i18n.tkey("lang_Half_body_photo")}}</span>
                    <br>
                    <span class="upload-img-label">({{i18n.tkey("lang_Aspect_ratio")}} 1:2 {{i18n.tkey("lang_Suggested_Resolution")}} 150*300)</span>
                    <UploadImg
                        v-model="userCard.addinfo9"
                        :size-limit="512"
                        :width="150"
                        :height="300"
                        :useBtn="false"
                        :autoUpdate="false"
                        @selectComplete="uploadHalfBodyImgCallback"
                        @deleteImg="deleteCardAddinfo9"
                    />
                </el-col>
            </el-row>

            <div v-if="null != cropperImgData" style="width: 100%; height: 350px">
                <ImgCropper
                    :imgUrl="cropperImgData"
                    :ratio="cropperImgRatio"
                    :size="0.4"
                    @saveComplete="cropImgCallback"
                />
            </div>
        </li>

        <li style="text-align: center" v-show="null == cropperImgData">
            <el-button type="primary" style="width: 250px; margin-bottom: 14px;" @click="clickSave" tkey="保存">{{i18n.tkey('lang_save')}}</el-button>
            <br>
<!--            <el-button type="danger" style="width: 250px" tkey="註銷">{{i18n.tkey('lang_log_off')}}</el-button>-->
        </li>

        <li>
            <div style="overflow: hidden; position: relative">
                <cardCompanyEditor v-if="saveCardFlag" @save-success="saveCallback" />
            </div>
        </li>

        <li>
            <record7Editor />
        </li>
    </ul>
</template>

<script setup>
    import {ref, toRef, getCurrentInstance, onMounted, inject, computed, onBeforeMount} from 'vue'
    import loginTextInput from "@/components/loginTextInput"
    import loginPasswordInput from "@/components/loginPasswordInput"
    import memmaleSelect from "@/components/shopopee/form/memmaleSelect"
    import areaNumberSelect from "@/components/shopopee/form/areaNumberSelect"
    import positionSelect from "@/components/shopopee/form/positionSelect"
    import departmentSelect from "@/components/shopopee/form/departmentSelect"
    import cardCompanyEditor from "@/components/shopopee/card/cardCompanyEditor"
    import record7Editor from "@/components/shopopee/record7/record7Editor"
    import UploadImg from "@/components/shopopee/form/uploadImg.vue";
    import ImgCropper from "@/components/shopopee/form/imgCropper.vue";
    import myUtil from "@/util/util";
    import companyApi from "@/request/companyApi";
    import {useUserinfo} from "@/stores/userinfo";

    const props = defineProps(["member"])
    const emits = defineEmits(["save-complete"])

    const userInfoRef = toRef(useUserinfo())

    const i18n = inject("i18n")

    const obj = ref({})
    const showPasswordInput = ref(false)
    const userCard = ref(null)

    const saveCardFlag = ref(false)
    const loading = ref(false)
    const cols = ref(12)

    const cropperImgData = ref(null)
    const cropperImgRatio = ref([1, 1])
    let cropperCallback = null

    const eshopopeeUrl = computed(() => {
        let url = "javascript: void(0)"

        if (null !== userInfoRef.value.acccompanycode){
            url = myUtil.generateEshopopeeManagerJumpUrl(userInfoRef.value.acccompanycode, userInfoRef.value.login, userInfoRef.value.password, "HRMember.asp?shopForm=shopopee")
        }

        return url
    })

    const eshopopeeTag = computed(() => {
        return null !== userInfoRef.value.acccompanycode
    })

    const { getCurrCard } = inject('myCardViewFunc', { getCurrCard: () => { return null } })

    function clickSave() {
        if (obj.value.password != obj.value.repassword){
            myUtil.alertWarning(i18n.tkey("lang_password_inconsistent"))
            return
        }

        if (myUtil.isEmpty(obj.value.name)){
            myUtil.alertWarning(i18n.tkey("lang_enter_complete"))
            return
        }

        if (myUtil.isEmpty(obj.value.telephone)){
            myUtil.alertWarning(i18n.tkey("lang_enter_complete"))
            return
        }

        saveInfo()
    }

    function saveInfo(){
        loading.value = true

        const request = companyApi.updateStaffInfo
        const params = request.getParams()

        params.addinfo2 = obj.value.addinfo2
        params.companycode = obj.value.companycode
        params.id = obj.value.id
        params.login = obj.value.login
        params.memmale = obj.value.memmale
        params.memposition = obj.value.memposition
        params.mpfaccount = obj.value.mpfaccount
        params.name = obj.value.name
        params.password = obj.value.password
        params.positionname = obj.value.positionname
        params.telephone = obj.value.telephone
        params.token = userInfoRef.value.token
        params.mobilephone = obj.value.mobilephone
        params.mpfratio = obj.value.mpfratio

        if (null != userCard.value){
            params.memberwork.id = userCard.value.id
            params.memberwork.addinfo8 = userCard.value.addinfo8
            params.memberwork.addinfo9 = userCard.value.addinfo9
        }

        request.send(params, (res) => {
            if (res.code == 200){
                saveCardFlag.value = true
            }else{
                myUtil.alertError(res.msg)
                loading.value = false
            }
        })
    }

    function saveCallback(){
        saveCardFlag.value = false
        loading.value = false
        myUtil.alertSuccess(i18n.tkey("lang_save_success"))
        emits("save-complete")
    }

    function deleteCardAddinfo8(){
        userCard.value.addinfo8 = "deleted"
    }

    function deleteCardAddinfo9(){
        userCard.value.addinfo9 = "deleted"
    }

    function uploadHeadImgCallback(value){
        uploadImgCallback(value, 0)
    }

    function uploadHalfBodyImgCallback(value){
        uploadImgCallback(value, 1)
    }

    function uploadImgCallback(value, type){
        if (type == 0){
            cropperImgRatio.value = [1, 1]
            cropperCallback = (base64) => {
                userCard.value.addinfo8 = base64
            }
        }else if(type == 1){
            cropperImgRatio.value = [1, 2]
            cropperCallback = (base64) => {
                userCard.value.addinfo9 = base64
            }
        }

        cropperImgData.value = value
    }

    function cropImgCallback(value){
        cropperImgData.value = null
        if (null != cropperCallback && typeof cropperCallback === "function"){
            cropperCallback(value)
            cropperCallback = null
        }
    }

    onBeforeMount(() => {
        let card = getCurrCard()

        if (null != card){
            card = JSON.stringify(card)
            userCard.value = JSON.parse(card)
        }

        if (!myUtil.isMobile()){
            cols.value = 12
        }
    })

    onMounted(() => {
        myUtil.mergeObj(props.member, obj.value)
        obj.value.repassword = props.member.password
    })

</script>

<style scoped>
    .inline-box {
        display: flex;
        align-items: center;
    }

    .inputs-ul {
        list-style: none;
        padding-left: 0;
        text-align: left;
        overflow-x: hidden;
    }

    .inputs-ul li {
        margin-top: 5px;
        margin-bottom: 5px;
    }

    .inline-text-input {
        width: calc(100% - 100px);
        box-sizing: border-box;
    }

    .inline-select {
        width: 100px;
        box-sizing: border-box;
    }

    .inline-text-input+.inline-select{
        padding-left: 5px;
    }

    .inline-select+.inline-text-input{
        padding-left: 5px;
    }

    .upload-img-label {
        font-size: 12px;
        line-height: 2;
    }
</style>